import { RadioButtonGroup } from '@resurs/midas-react'
import PropTypes from 'prop-types'
import React from 'react'

class RadioButtons extends React.PureComponent {
  constructor(props) {
    super(props)
    let defaultValueIndex = -1
    if (this.props.defaultValue) {
      defaultValueIndex = this.props.values.findIndex(
        value => value.value === this.props.defaultValue,
      )
    }
    this.state = {
      defaultValueIndex: defaultValueIndex !== -1 ? defaultValueIndex : 0,
    }
  }

  componentDidMount() {
    this.props.onChange(this.props.values[this.state.defaultValueIndex].value)
  }

  render() {
    const { id, label, onChange, values } = this.props
    return (
      <RadioButtonGroup
        id={id}
        label={label}
        values={values}
        defaultCheckedValue={values[this.state.defaultValueIndex].value}
        onChange={e => onChange(e.target.value)}
        name={id}
        inline
      />
    )
  }
}

RadioButtons.propTypes = {
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  values: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      value: PropTypes.any.isRequired,
      valueLabel: PropTypes.string.isRequired,
    }),
  ).isRequired,
  defaultValue: PropTypes.any,
}

RadioButtons.defaultProps = {
  defaultValue: null,
}

export default RadioButtons
